import Vue from 'vue'
import Vuetify, { VBtn, VLayout, VFlex } from 'vuetify2/lib'

import icons from '~/util/icons.js'

// CSS
import '~/assets/css/snui/overrides.sass'
import '~/assets/css/snIcons.css'
import '~/assets/css/snui/index.scss'

import * as svgIcons from './icons/index.js'
// eslint-disable-next-line
const snIcons = Object.keys(svgIcons).reduce((dict, iconName) => ({ ...dict, [`sn${iconName}`]: { component: svgIcons[iconName] } }), {})

VBtn.options.props.depressed.default = true

Vue.use(Vuetify, {
  components: {
    VLayout,
    VFlex
  }
})

const opts = {
  breakpoint: {
    thresholds: {
      xs: 320,
      sm: 540,
      md: 990,
      lg: 1280
    }
  },
  icons: {
    values: {
      ...icons,
      ...snIcons
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#FFFFFF'
      },
      dark: {
        tertiary: '#1F1F1F'
      }
    }
  }
}

export default new Vuetify(opts)
